import React, { Fragment, useEffect, useState } from 'react';
import { makeStyles, Grid, Paper } from '@material-ui/core';
import { palette } from 'configurations/styles/theme';
import bigDecimal from 'js-big-decimal';


const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.primary,
        margin: theme.spacing(1),
        display: 'flex',
        flexWrap: 'wrap',
        marginBottom: '1%',
        borderStyle: 'solid',
        boxShadow: "5px 3px 3px #aaaaaa",
        borderRadius: '8px',
        borderWidth: '1px'
    },
    formControl: {
        marginTop: theme.spacing(0),
        minWidth: 120,

    },
    radio: {
        display: '-webkit-box',
        marginTop: '0px'
    },
    radioLable: {
        color: palette.primary.main,
        display: 'flex'
    },
    radioButton: {
        marginTop: '0px',
        paddingTop: '0px'
    },
    divForm: {
        marginBottom: '1%',
        textAlign: 'justify',
    },
    divInput: {
        marginBottom: '1%',
        paddingRight: '1%',
        paddingLeft: '0.5%',
        textAlign: 'justify',

    },
    divButton: {
        paddingLeft: '3%',
        paddingRight: '3%'
    },
    backdrop: {
        zIndex: theme.zIndex.modal + 999,
        color: palette.primary.main,
    },
    haedClient: {
        backgroundColor: palette.primary.main,
        width: '1%',
        marginBottom: '2%',
        display: 'flex',
        flexWrap: 'wrap',
        marginBottom: '1%',
        borderStyle: 'solid',
        borderBottomWidth: '5px',
        borderRadius: '8px',
    },
    paper: {
        padding: theme.spacing(2),
        margin: 'auto',
        maxWidth: 500,
        borderRadius: "8px",
        marginBottom: '2%',
        borderRadius: '8px',
        borderWidth: '1px',
        borderStyle: 'solid',
    },
    totalLabel: {
        padding: "2%",
        borderRadius: "8px",
        borderWidth: "1px",
        borderStyle: "solid",
        marginBottom: "1%"
    },
    contInput: {
        textAlign: 'end',
        display: 'block',
        width: '100%',
        height: 'calc(1.5em + .75rem + 2px)',
        padding: '.375rem .75rem',
        fontSize: '1rem',
        fontWeight: '400',
        lineHeight: '1.5',
        color: '#495057',
        backgroundClip: 'padding-box',
        border: '1px solid #ced4da',
        borderRadius: '.25rem',
        transition: 'border-color .15s ease-in-out,box-shadow .15s ease-in-out',
    },
    totalLabel: {
        padding: "2%",
        borderRadius: "8px",
        borderWidth: "2px",
        borderStyle: "solid",
        marginBottom: "1%"
    }
}));

const Calculations = ({ totals, setTotals, discountVoucher, retentionVoucher }) => {
    const [totRetention, setTotRetention] = useState('0');
    const classes = useStyles();
    useEffect(() => {
        let ret = retentionVoucher;
        if (ret === "1" || ret === "3") {
            setTotRetention(totals.totalItbms);
        } else if (ret === "2" || ret === "4" || ret === "7") {
            setTotRetention(totals.totalItbms / 2);
        } else {
            setTotRetention(0);
        }
    }, [retentionVoucher, totals.totalItbms])

    const handleChange = event => {
        event.preventDefault();
        const re = /^[0-9\b.]{1,14}$/;
        if (event.target.value === '' || re.test(event.target.value)) {
            if (Number(event.target.value.trim()) >= 0) {
                setTotals({ ...totals, ['totalPropina']: event.target.value });
            }
        }
    }

    const calculateSubTotalFactura = () => bigDecimal.round(
        bigDecimal.add(totals.totalFactura, totals.totalPropina),
        6,
        bigDecimal.RoundingModes.HALF_UP);

    const calculatetotalFactura = () => {
        let totalDiscount = new bigDecimal("0");
        let subTotalVoucher = calculateSubTotalFactura();
        discountVoucher.forEach((pr) => {
            let prValor = new bigDecimal(pr.valor);
            prValor = prValor.round(6, bigDecimal.RoundingModes.HALF_UP);
            totalDiscount = totalDiscount.add(prValor);
        });
        subTotalVoucher = new bigDecimal(subTotalVoucher);
        let totalVoucher = subTotalVoucher.subtract(totalDiscount)
        return totalVoucher.value;
    }
    return (
        <Fragment>
            <div className={classes.root} >
                <Paper className={classes.paper}>
                    <Grid container fullWidth maxWidth="xs" spacing={2}>
                        <Grid item xs={5} className={classes.divForm}>
                            <label>Subtotal sin Impuestos:</label>
                        </Grid>
                        <Grid item xs={7} className={classes.divInput}>
                            <input className={classes.contInput}
                                type="text"
                                disabled
                                placeholder="Ej. 0.0"
                                name="subTotalSinImpuestos"
                                value={bigDecimal.round(totals.subTotalSinImpuestos, 6, bigDecimal.RoundingModes.HALF_UP)}
                            />
                        </Grid>
                        <Grid item xs={5} className={classes.divForm}>
                            <label>Subtotal 7%:</label>
                        </Grid>
                        <Grid item xs={7} className={classes.divInput}>
                            <input className={classes.contInput}
                                type="text"
                                disabled
                                placeholder=" Ej. 0.0"
                                name="subTotal_12"
                                value={totals.subTotal_12}
                                textAlign='left'

                            />
                        </Grid>

                        <Grid item xs={5} className={classes.divForm}>
                            <label>Subtotal 10%:</label>
                        </Grid>
                        <Grid item xs={7} className={classes.divInput}>
                            <input className={classes.contInput}
                                type="text"
                                disabled
                                placeholder=" Ej. 0.0"
                                name="subtotal_10"
                                value={bigDecimal.round(totals.subTotal_10, 6, bigDecimal.RoundingModes.HALF_UP)}
                            />
                        </Grid>

                        <Grid item xs={5} className={classes.divForm}>
                            <label>Subtotal 15%:</label>
                        </Grid>
                        <Grid item xs={7} className={classes.divInput}>
                            <input className={classes.contInput}
                                type="text"
                                disabled
                                placeholder="Ej. 0.0"
                                name="subTotal_14"
                                value={bigDecimal.round(totals.subTotal_14, 6, bigDecimal.RoundingModes.HALF_UP)}
                            />
                        </Grid>
                        <Grid item xs={5} className={classes.divForm}>
                            <label>Subtotal 0%:</label>
                        </Grid>
                        <Grid item xs={7} className={classes.divInput}>
                            <input className={classes.contInput}
                                type="text"
                                disabled
                                placeholder="Ej. 0.0"
                                name="subTotal_noIva"
                                value={bigDecimal.round(totals.subTotal_noIva, 6, bigDecimal.RoundingModes.HALF_UP)}
                            />
                        </Grid>

                        <Grid item xs={5} className={classes.divForm}>
                            <label>Total Descuento:</label>
                        </Grid>
                        <Grid item xs={7} className={classes.divInput}>
                            <input className={classes.contInput}
                                type="text"
                                disabled
                                placeholder=" Ej. 0.0"
                                name="totalDescuento"
                                value={bigDecimal.round(totals.totalDescuento, 6, bigDecimal.RoundingModes.HALF_UP)}
                            />
                        </Grid>
                        <Grid item xs={5} className={classes.divForm}>
                            <label>Retenciones:</label>
                        </Grid>
                        <Grid item xs={7} className={classes.divInput}>
                            <input className={classes.contInput}
                                type="text"
                                disabled
                                placeholder=" Ej. 0.0"
                                name="totRetention"
                                value={bigDecimal.round(totRetention, 6, bigDecimal.RoundingModes.HALF_UP)}
                            />
                        </Grid>

                    </Grid>
                </Paper>

                <Paper className={classes.paper}>
                    <Grid container fullWidth maxWidth="xs" spacing={2}>
                        <Grid item xs={5} className={classes.divForm}>
                            <label>Seguro:</label>
                        </Grid>
                        <Grid item xs={7} className={classes.divInput}>
                            <input className={classes.contInput}
                                type="text"
                                disabled
                                placeholder="Ej. 0.00"
                                name="totalSeguro"
                                value={bigDecimal.round(totals.totalSeguro, 6, bigDecimal.RoundingModes.HALF_UP)}
                            />
                        </Grid>
                        <Grid item xs={5} className={classes.divForm}>
                            <label>Acarreo:</label>
                        </Grid>
                        <Grid item xs={7} className={classes.divInput}>
                            <input className={classes.contInput}
                                type="text"
                                disabled
                                placeholder="Ej. 0.00"
                                name="totalAcarreo"
                                value={bigDecimal.round(totals.totalAcarreo, 6, bigDecimal.RoundingModes.HALF_UP)}
                            />
                        </Grid>
                        <Grid item xs={5} className={classes.divForm}>
                            <label>OTI:</label>
                        </Grid>
                        <Grid item xs={7} className={classes.divInput}>
                            <input className={classes.contInput}
                                type="text"
                                disabled
                                placeholder="Ej. 0.00"
                                name="totalIce"
                                value={bigDecimal.round(totals.totalIce, 6, bigDecimal.RoundingModes.HALF_UP)}
                            />
                        </Grid>
                        <Grid item xs={5} className={classes.divForm}>
                            <label>ISC:</label>
                        </Grid>
                        <Grid item xs={7} className={classes.divInput}>
                            <input className={classes.contInput}
                                type="text"
                                disabled
                                placeholder="Ej. 0.00"
                                name="totalIsc"
                                value={bigDecimal.round(totals.totalIsc, 6, bigDecimal.RoundingModes.HALF_UP)}
                            />
                        </Grid>
                        <Grid item xs={5} className={classes.divForm}>
                            <label>ITBMS 7%:</label>
                        </Grid>
                        <Grid item xs={7} className={classes.divInput}>
                            <input className={classes.contInput}
                                type="text"
                                disabled
                                placeholder=" Ej. 0.0"
                                name="totalIva_12"
                                value={bigDecimal.round(totals.totalIva_12, 6, bigDecimal.RoundingModes.HALF_UP)}
                            />
                        </Grid>
                        <Grid item xs={5} className={classes.divForm}>
                            <label>ITBMS 10%:</label>
                        </Grid>
                        <Grid item xs={7} className={classes.divInput}>
                            <input className={classes.contInput}
                                type="text"
                                disabled
                                placeholder=" Ej. 0.0"
                                name="totalIva_10"
                                value={bigDecimal.round(totals.totalIva_10, 6, bigDecimal.RoundingModes.HALF_UP)}
                            />
                        </Grid>

                        <Grid item xs={5} className={classes.divForm}>
                            <label>ITBMS 15%:</label>
                        </Grid>
                        <Grid item xs={7} className={classes.divInput} >
                            <input className={classes.contInput}
                                type="text"
                                disabled
                                placeholder=" Ej. 0.0"
                                name="totalIva_14"
                                value={bigDecimal.round(totals.totalIva_14, 6, bigDecimal.RoundingModes.HALF_UP)}
                                justtify='flex-end'
                            />
                        </Grid>
                        <Grid item xs={5} className={classes.divForm}>
                            <label>Total ITBMS:</label>
                        </Grid>
                        <Grid item xs={7} className={classes.divInput}>
                            <input className={classes.contInput}
                                type="text"
                                disabled
                                placeholder=" Ej. 0.0"
                                name="totalItbms"
                                value={bigDecimal.round(totals.totalItbms, 6, bigDecimal.RoundingModes.HALF_UP)}
                            />
                        </Grid>
                    </Grid>
                </Paper>

                <Grid container justify='center' fullWidth maxWidth="xs" spacing={2} >
                    <Grid item xs={12} md={10} className={classes.totalLabel} align="center">
                        {//<strong>Importe Total: {bigDecimal.round(bigDecimal.add(totals.totalFactura, totals.totalPropina), 2, bigDecimal.RoundingModes.HALF_UP)}</strong>
                        }
                        <strong>Subtotal: {calculateSubTotalFactura()}</strong>
                    </Grid>
                </Grid>
                <br></br>
                <Grid container justify='center' fullWidth maxWidth="xs" spacing={2} >
                    <Grid item xs={12} md={10} className={classes.totalLabel} align="center">
                        {//<strong>Importe Total: {bigDecimal.round(bigDecimal.add(totals.totalFactura, totals.totalPropina), 2, bigDecimal.RoundingModes.HALF_UP)}</strong>
                        }
                        <strong>Importe Total: {bigDecimal.round(calculatetotalFactura(), 2, bigDecimal.RoundingModes.HALF_UP)}</strong>
                    </Grid>
                </Grid>
            </div>
        </Fragment>

    );
}

export default Calculations;
